<div class="order-app-dialog" *ngIf="isNewPlanPage">
  <p-dialog
    header=""
    [modal]="true"
    [(visible)]="verifyCustomer"
    [style]="{ width: '542px', height: '463px' }"
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
  >
    <customer-verification-dialog (closeDialog)="closeDialog()" [customerOfferId]="customerOfferId"></customer-verification-dialog>
  </p-dialog>
</div>

<lib-order-overview
  [ngStyle]="{ filter: verifyCustomer && isNewPlanPage ? 'blur(10px)' : 'none' }"
  [heading]="headingTemplate"
  [leftContent]="leftContentTemplate"
  [rightContent]="rightContentTemplate"
></lib-order-overview>

<ng-template #headingTemplate>
  <h2>Alle Daten im Überblick</h2>
  <p>Bitte überprüfen und ergänzen Sie alle Angaben.</p>
</ng-template>

<ng-template #leftContentTemplate>
  <form [formGroup]="orderForm" (ngSubmit)="onFormSubmit()">
    <lib-order-contact (contactForm$)="formInitialized($event)" [isNewCustomer]="isNewPlanPage">></lib-order-contact>
    <lib-order-customer-info (contactForm$)="formInitialized($event)" *ngIf="isNewPlanPage"></lib-order-customer-info>
    <lib-order-details></lib-order-details>
  </form>
</ng-template>

<ng-template #rightContentTemplate>
  <form [formGroup]="orderForm" (ngSubmit)="onFormSubmit()">
    <lib-order-summary
      (orderSummaryForm)="formInitialized($event)"
      (onSubmit)="onFormSubmit()"
      [isNewCustomer]="isNewPlanPage"
      [orderFormValid]="orderFormValid"
    ></lib-order-summary>
  </form>
</ng-template>

<lib-faqs [isPaddingY]="true" *ngIf="!isNewPlanPage"></lib-faqs>
